export class AddOrderItemExceptionModel {
    private _reason: string;
    private _variantString: string;

    constructor(reason: string, variantString: string = "") {
        this._reason = reason;
        this._variantString = variantString;
    }

    public get reason(): string {
        return this._reason;
    }

    public get variantString(): string {
        return this._variantString;
    }
}
